import {useQuery} from "react-query";
import {QUERY_KEYS} from "../query-keys";
import {me} from "../../api/AlfyApiClient";

export const useUserMe = () => {
    return useQuery([QUERY_KEYS.USER], async () => {
        return await me()
    }, {
        onError: (error: any) => {
            console.error(error)
        }
    })
}